var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../../styles/ResultGrid.module.scss';
import Row from "./Row";
import Headers from "./Headers";
var ROWS = [0, 1, 2, 3, 4, 5];
var ResultGrid = function (_a) {
    var answerCard = _a.answerCard, guesses = _a.guesses;
    return (_jsxs("div", __assign({ className: styles.tableContainer }, { children: [_jsx(Headers, {}, void 0), ROWS.map(function (row) { return (_jsx(Row, { guesses: guesses, answerCard: answerCard, row: row }, row)); })] }), void 0));
};
export default ResultGrid;
